import { render, staticRenderFns } from "./miscellaneousFee.vue?vue&type=template&id=90c1cebc&scoped=true"
import script from "./miscellaneousFee.vue?vue&type=script&lang=js"
export * from "./miscellaneousFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c1cebc",
  null
  
)

export default component.exports